<script context="module">
  // context="module" makes this exportable
  export const WIDTH = 124;
</script>

<script>
  import { createEventDispatcher } from 'svelte';

  import { onTabFocus } from '../../../../../js/onTabFocus';
  import { blurOnClick } from '../../../../../js/blurOnClick';
  import { trackLinkClick } from '../../../../../js/trackLinkClick';

  const dispatch = createEventDispatcher();

  export let id = '';
  export let title = '';
  export let subtitle = '';
  export let url = '';
  export let image = null;
</script>

<a
  {id}
  href={url}
  class="ImageLink"
  style="min-width: {WIDTH}px;"
  use:blurOnClick
  use:onTabFocus={(e) => dispatch('tabFocus', e)}
  use:trackLinkClick={{ id, title, url }}
>
  {#if image}
    <img aria-hidden="true" alt="" class="image" src={image} width="80" height="70" />
  {/if}
  {#if title}<span class="title">{title}</span>{/if}
  {#if subtitle}<span class="subtitle">{subtitle}</span>{/if}
</a>

<style>@charset "UTF-8";
.ImageLink {
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 0;
  text-align: center;
  border-radius: 4px;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  letter-spacing: normal;
  text-decoration: none;
  white-space: normal;
}
.ImageLink::-moz-focus-inner {
  border: 0;
}
.ImageLink:focus {
  outline: none;
}
.ImageLink::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 100ms cubic-bezier(0.4, 0, 0.2, 1), transform 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0);
}
.ImageLink:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
@media (hover: hover) {
  .ImageLink:hover::before {
    opacity: 1;
    transform: scale(1);
  }
}
.ImageLink > * {
  position: relative;
}

.title {
  display: block;
  font-size: 12px;
  line-height: 12px;
  font-weight: var(--font-weight-medium, 500);
  white-space: nowrap;
}

.subtitle {
  display: block;
  font-size: 12px;
  line-height: 12px;
  margin-top: 4px;
  white-space: nowrap;
}

.image {
  display: block;
  width: 80px;
  height: 70px;
  margin: 0 auto;
}</style>
